<div class="page-content" *ngIf="!timerService.isForwarding">

     <div><button class="btn-back" title="{{Button.Back_alt | translate}}" (click)="onPreviousClick()" translate>{{Button.Previous}}</button></div>

     <h1 class="page_title" translate>{{'SIN_main.page_title'}}</h1>

     <p class="page-title" translate>
      {{ 'SIN_main.save_yourself_time' }}
     </p>

     <p class="page-title" translate>
      {{ 'SIN_main.your_child_will_need' }}
     </p>

     <div class="sin-out-div">
       <div class="sin-in-div" translate='SIN_main.9_out_of_10'></div> 
     </div>
     
      <accordion label="SIN_main.accord_eligibility.header" outer-class="bottom-margin">
            <div class="page-title" translate='SIN_main.accord_eligibility.text1'>
                  <a-link link-url="SIN_main.accord_eligibility.link1"
                      alt-text="SIN_main.accord_eligibility.alt1"
                      label='SIN_main.accord_eligibility.link_text1'>
                  </a-link><span>.</span>
            </div>
            <div class="page-title" style="margin-top: 0.6em;" translate='SIN_main.accord_eligibility.text2'></div> 
      </accordion>

      <div [hidden]="parentCount > 2">
            <p class="page-title" translate>
            {{ 'SIN_main.apply_for_SIN_1_2' |translate:childNameParam}}
            </p>
            <div *ngFor="let pname of data.parentList" class="parents-div">
                  <strong>{{pname.name.getFullName()}}</strong>
            </div>
      </div>
     
      <div [hidden]="parentCount <= 2" id="parents">
            <p class="page-title" translate>
            {{ 'SIN_main.apply_for_SIN_3_4' |translate:childNameParam}}
            </p>

            <div *ngFor="let parent of data.parentList; let i = index">            
                  <ng-checkbox [(ng-model)]="parent.isSINParent" id="parentsCheckbox{{i}}"
                               [(ng-clear)]="error_chkParents"
                               (change)="parentCheck()"> 

                   <strong>{{parent.name.getFullName()}}</strong>
                       
                  </ng-checkbox>
             </div>
     </div>
     <br/>

     <errors [error]="error_chkParents"></errors>

     <h2 id="read" translate='SIN_main.notice_of_collection'></h2> 
     
     <ng-checkbox [(ng-model)]="sin.chk_read" id="readCheckbox"
                  [(ng-error)]="error_chkRead"
                  (click)=onMyClick($event)
                  [title]="'SIN_main.notice.chk_alt' | translate">
          <span translate='SIN_main.notice.chk_t1'></span>
          <a-link (click)=onMyClick($event)
                      alt-text="SIN_main.notice.chk_link_alt"
                      label='SIN_main.notice.chk_link_text'> 
          </a-link>
          <span translate='SIN_main.notice.chk_t2'></span>
    </ng-checkbox>

     <light-box input-class="white-box" outer-style="font-size:0.88em; margin-top:1em">

      <div style="margin-left: 0.9em; margin-right: 0.9em; padding-top: 0.4em;">
      <information outer-class="full">
            <div class="info-title"> 
            <strong>
                  <span translate='SIN_main.lightbox.please_select_1'></span>
                  <span translate='SIN_main.lightbox.i_agree' [hidden]="parentCount != 1"></span>
                  <span translate='SIN_main.lightbox.we_agree' [hidden]="parentCount == 1"></span>
                  <span translate='SIN_main.lightbox.please_select_2'></span>
            </strong>
            </div>
      </information>
      </div>
             <h3 translate='SIN_main.lightbox.notice'
              class='header-lightbox'>
             </h3>  
             <div class="margin1">
                   <div [innerHTML]="'SIN_main.lightbox.text1' | translate"></div>
                   <div style="margin-top: 0.5em;" translate='SIN_main.lightbox.text2'></div>
                   <div style="margin-top: 0.5em;">
                        <span translate='SIN_main.lightbox.text3_1'></span>
                        <a-link link-url="SIN_main.lightbox.text3_link1"
                                alt-text="SIN_main.lightbox.text3_alt"
                                label='SIN_main.lightbox.text3_link_text1'>
                        </a-link><span>.</span>
                        <span translate='SIN_main.lightbox.text3_2'></span>
                        <a-link link-url="SIN_main.lightbox.text3_link2"
                                alt-text="SIN_main.lightbox.text3_alt"
                                label='SIN_main.lightbox.text3_link_text2'>
                         </a-link><span>.</span>
                   </div>

                   <div role="button" style="margin:2em 1em 1.8em 1em" style="float:right; cursor:pointer">
                   <a tabindex="0" (click)="onMyClose()" (keypress)="keyPress($event)"
                       style="margin-right:1em"  translate='SIN_main.lightbox.close'>
                   </a>
                  </div>

                   <div class="btn-div" style="margin-top: 3em;">
                   
                   <button class="btn-next-notice" alt-text='SIN_main.lightbox.agree_alt' (click)=parentAgree()>
                          <span translate='SIN_main.lightbox.i_agree' [hidden]="parentCount != 1"></span>
                          <span translate='SIN_main.lightbox.we_agree' [hidden]="parentCount == 1"></span>
                   </button>
                   
                   </div>
            </div>
     
     </light-box>

     <h2 id="certify" style="margin-top: 0.8em;" translate ='SIN_main.statement_of_certification'></h2>  
     
     <ng-checkbox [(ng-model)]="sin.chk_certify" id="certifyCheckbox"
                  [(ng-error)]="error_chkCertify"> 
          <span translate='SIN_main.statement_chk'></span>
    </ng-checkbox>

     <div class="btn-div">
            <div class="button-top">
                  <button [ngClass]="data.subject.language=='fr'?'btn-next3':'btn-next2'"  
                          title="{{Button.Next_alt|translate}}" (click)="onNextClick()" translate>{{Button.Next}}</button></div>
            <div class="button-bottom">
                  <button [ngClass]="data.subject.language=='fr'?'btn-cancel3':'btn-cancel2'"  
                          alt-text='SIN_main.not_apply_alt' (click)="notApply()" translate>{{"SIN_main.button_not_apply"}}</button></div>
      </div>

</div>
